<template>
  <div class="pagination">
    <el-pagination
      background
      :current-page.sync="currentPage"
      :page-size.sync="limit"
      :layout="layout"
      :page-sizes="pager"
      :total="total"
      @size-change="sizeChange"
      @current-change="entryChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
		//数据总条数
    total: {
      required: true,
      type: Number
    },
		//分页的当前页号
    page: {
      type: Number,
      default: 1
    },
		//分页条目数
    pageSize: {
      type: Number,
      default: 5
    },
		//设置每次查询的条数
    pageSizes: {
      type: Array,
      default() {
        return [5,10, 20, 30, 50]
      }
    },
		//设置分页的结构，是否有跳转，下一页等等
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next'
    },
  },
  computed: {
		//利用计算属性重置分页的页数和条目。避免单项数据流冲突
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    limit: {
      get() {
        return this.pageSize
      },
      set(val) {
        this.$emit('update:pageSize', val)
      }
    },
    pager:{
      get() {
        return this.pageSizes
      },
      set(val) {
        this.$emit('update:pageSizes', val)
      }
    }
  },
  methods: {
    sizeChange(val) {
      console.log(val)
      this.$emit('pagechange', { page: this.currentPage, pageSize: val })
    },
    entryChange(val) {
      this.$emit('pagechange', { page: val, pageSize: this.limit })
    }
  }
}
</script>

<style scoped>
.pagination { background: #fff; padding: 0px 16px; }
</style>
